import { render, staticRenderFns } from "./create_inairequipment.vue?vue&type=template&id=2a595324&"
import script from "./create_inairequipment.vue?vue&type=script&lang=ts&"
export * from "./create_inairequipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports